export default __webpack_public_path__ + "statics/OpenDyslexic-Regular.woff";